module.exports = __webpack_public_path__ + "img/team_04.36ff3adc.jpg";